
import {merge as observableMerge, fromEvent as observableFromEvent, Observable, BehaviorSubject} from 'rxjs';

import {distinctUntilChanged, debounceTime,  map } from 'rxjs/operators';
import {Component , ElementRef , OnInit , ViewChild} from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {TargetGroupService} from '../../../../core/services/targetGroup.service';
import {DataSource} from '@angular/cdk/collections';
import {fuseAnimations} from '../../../../core/animations';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import {FuseUtils} from '../../../../core/fuseUtils';
import {TargetGroupFormDialogComponent} from './setting-form/setting-form.component';
import {Router} from '@angular/router';
import {NgxSpinnerService} from 'ngx-spinner';

@Component({
    selector: 'target-group-page',
    templateUrl: './target-group.component.html',
    styleUrls: ['./target-group.component.scss'],
    animations: fuseAnimations,
    standalone: false
})
export class TargetGroupComponent implements OnInit {
  targetGroups: FilesDataSource | null;
  access;
  displayedColumns = [ 'ageMask' , 'targetNumber', 'abbreviation' ];
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild('filter', {static: true}) filter: ElementRef;
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  dialogRef: any;

  constructor (private http: HttpClient , private targetGroupService: TargetGroupService , private router: Router,
               public dialog: MatDialog , public snackBar: MatSnackBar, public spinner: NgxSpinnerService) {
    this.targetGroupService.onAccessChanges.subscribe((res) => {
      if (res.detail) {
        this.displayedColumns = [ 'ageMask' ,  'targetNumber', 'abbreviation' , 'group' , 'active', 'creditTarget', 'carryForward' ];
      } else {
        this.displayedColumns = [ 'ageMask' , 'targetNumber', 'abbreviation', 'group', 'showInFront' ];
      }
      this.access = res;
    });
  }

  ngOnInit () {
    this.init();
  }

  init() {
    this.spinner.show();
    this.targetGroupService.getTargetGroups().then((data: any) => {
      this.getDataType();
      this.spinner.hide();
    });
  }

  getDataType () {
    this.targetGroups = new FilesDataSource(this.targetGroupService , this.paginator , this.sort);
    observableFromEvent(this.filter.nativeElement , 'keyup').pipe(
      debounceTime(150),
      distinctUntilChanged())
      .subscribe(() => {
        if (!this.targetGroups) {
          return;
        }
        this.targetGroups.filter = this.filter.nativeElement.value;
      });
  }

  newTargetGroup () {
    this.dialogRef = this.dialog.open(TargetGroupFormDialogComponent , {
      panelClass: 'contact-form-dialog' ,
      width: '450px',
      data: {
        action: 'new'
      }
    });

    this.dialogRef.afterClosed()
      .subscribe((response: any) => {
        const data = response[ 0 ].value;
        this.targetGroupService.addTargetGroup(data).subscribe((res) => {
          if (res) {
            this.snackBar.open('Target Group added.' , '' , {duration: 2500});
            this.targetGroupService.getTargetGroups().then();
          }
        } , error => {
          this.snackBar.open('Add failed.' , '' , {duration: 2500});
        });
      });

  }

  editTargetGroup (level) {
    if (this.access.edit) {
      this.dialogRef = this.dialog.open(TargetGroupFormDialogComponent , {
        panelClass: 'contact-form-dialog' ,
        width: '450px',
        data: {
          type: level ,
          action: 'edit'
        }
      });

      this.dialogRef.afterClosed()
        .subscribe(response => {
          if (!response) {
            return;
          }
          console.log(response);
          const actionType: string = response[ 0 ];
          const data = response[ 1 ].value;
          data.id = level.id;
          switch (actionType) {
            /**
             * Save
             */
            case 'save':


              this.targetGroupService.addTargetGroup(data).subscribe((res) => {
                if (res) {
                  this.snackBar.open('Target Group updated.' , '' , {duration: 2500});
                  this.targetGroupService.getTargetGroups().then();
                }
              } , error => {
                this.snackBar.open('Update failed.' , '' , {duration: 2500});
              });
              break;
            /**
             * Delete
             */
            case 'delete':
              this.targetGroupService.deleteTargetGroup(level.id).subscribe((res) => {
                if (res) {
                  this.snackBar.open('Target Group deleted.' , '' , {duration: 2500});
                  this.targetGroupService.getTargetGroups().then();
                }
              } , error => {
                this.snackBar.open('Delete failed.' , '' , {duration: 2500});
              });

              break;
          }
        });
    }
    if (this.access.detail) {
      if (level.setting.id) {
        this.router.navigate(['/pages/settings/target-group-setting'], {queryParams: {id: level.setting.id, targetGroupId: level.id}} );
      } else {
        this.router.navigate([ '/pages/settings/target-group-setting' ], {queryParams: {targetGroupId: level.id}});
      }
    }
  }
}

export class FilesDataSource extends DataSource<any> {
  _filterChange = new BehaviorSubject('');
  _filteredDataChange = new BehaviorSubject('');

  get filteredData (): any {
    return this._filteredDataChange.value;
  }

  set filteredData (value: any) {
    this._filteredDataChange.next(value);
  }

  get filter (): string {
    return this._filterChange.value;
  }

  set filter (filter: string) {
    this._filterChange.next(filter);
  }

  constructor (private targetGroupService: TargetGroupService ,
               private _paginator: MatPaginator ,
               private _sort: MatSort) {
    super();
    this.filteredData = this.targetGroupService.targetGroup;
  }

  /** Connect function called by the table to retrieve one stream containing the data to render. */
  connect (): Observable<any[]> {
    const displayDataChanges = [
      this.targetGroupService.onTargetGroupChanged ,
      this._paginator.page ,
      this._filterChange ,
      this._sort.sortChange
    ];

    return observableMerge(...displayDataChanges).pipe(map(() => {
      let data = this.targetGroupService.targetGroup.slice();

      data = this.filterData(data);

      this.filteredData = [ ...data ];

      data = this.sortData(data);

      // Grab the page's slice of data.
      const startIndex = this._paginator.pageIndex * this._paginator.pageSize;
      return data.splice(startIndex , this._paginator.pageSize);
    }));
  }

  filterData (data) {
    console.log(data);
    if (!this.filter) {
      return data;
    }
    return FuseUtils.filterArrayByString(data , this.filter);
  }

  sortData (data): any[] {
    if (!this._sort.active || this._sort.direction === '') {
      return data;
    }

    return data.sort((a , b) => {
      let propertyA: number | string = '';
      let propertyB: number | string = '';

      switch (this._sort.active) {
        case 'ageMask':
          [ propertyA , propertyB ] = [ a.ageMask , b.ageMask ];
          break;
        case 'targetNumber':
          [ propertyA , propertyB ] = [ a.targetNumber , b.targetNumber ];
          break;
        case 'abbreviation':
          [ propertyA , propertyB ] = [ a.abbreviation , b.abbreviation ];
          break;
        case 'group':
          [ propertyA , propertyB ] = [ a.group ? a.group.name : '', b.group ? b.group.name : ''];
          break;
        case 'message':
          [ propertyA , propertyB ] = [ a.welcomeMsg , b.welcomeMsg ];
          break;


      }

      const valueA = isNaN(+propertyA) ? propertyA : +propertyA;
      const valueB = isNaN(+propertyB) ? propertyB : +propertyB;

      return (valueA < valueB ? -1 : 1) * (this._sort.direction === 'asc' ? 1 : -1);
    });
  }

  disconnect () {
  }
}
